import { CircularProgress } from '@mui/material';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';
import { LegacyButtonVariant } from 'apps/sigma2-ui/src/components/ui/Buttons';
import { LegacyButton } from 'apps/sigma2-ui/src/components/ui/LegacyButton';

export const CallbackLogoutPage = () => {
  const { myUserStatus, logout } = useUser();
  const navigate = useNavigateSafe();

  const isLoading = useMemo(() => {
    return myUserStatus === 'logging_out';
  }, [myUserStatus]);

  const isLoggedOut = useMemo(() => {
    return myUserStatus === 'logged_out';
  }, [myUserStatus]);

  const onBackToHomePageClick = useCallback(() => {
    if (!isLoggedOut) {
      return;
    }
    navigate('/');
  }, [navigate, isLoggedOut]);

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <>
      <div className="flex flex-col items-center justify-center h-screen">
        {isLoading && <div className="text-2xl font-bold">Logging out</div>}
        {isLoading && (
          <CircularProgress
            color="inherit"
            className="text-secondary"
            size={96}
            thickness={8}
          />
        )}
        {isLoggedOut && <div className="text-2xl font-bold">Logged out</div>}
        {isLoggedOut && (
          <LegacyButton
            variant={LegacyButtonVariant.PRIMARY_DARK}
            onClick={onBackToHomePageClick}
          >
            Back to home page
          </LegacyButton>
        )}
        {!isLoggedOut && !isLoading && (
          <LegacyButton
            variant={LegacyButtonVariant.PRIMARY_DARK}
            onClick={onBackToHomePageClick}
          >
            Back to home page
          </LegacyButton>
        )}
      </div>
    </>
  );
};
